export default __webpack_public_path__ + "static/media/load.00c3967e.gif";